// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"login_loginPage__13qpE","btnOrange":"login_btnOrange__2zCbV"};